import { AttributeValue } from "../../../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../../library-js/dom-tools/EventListeners";
import { Link, LinkType } from "../../../../library-js/dom-tools/LinkResolver";
import { ContextMenu } from "../../../../library-templates/context--menu/ContextMenu";
import { ContextMenuCreator } from "../../../../library-templates/context--menu/ContextMenuCreator";
import { Rokojori } from "../../Rokojori";
import { HeaderMenu } from "../HeaderMenu";
import { LinkContextEntry } from "../LinkContextMenuEntry";


export class News_en extends ContextMenuCreator
{
  static value = new AttributeValue( ContextMenuCreator.attribute, "news-en" );
  
  get value(){ return News_en.value }
  
  create( e:Element ):ContextMenu
  {
    let entries:LinkContextEntry[] =
    [
      { label:"Overview", link:"::/en/news/overview" },
      { label:"About", link:"::/en/about" },
      { label:"Blog", link:"::/en/news/blog" },
      { label:"Game Dev Events", link:"::/en/news/game-dev-events" },
      { label:"Gaming Magazines", link:"::/en/news/gaming-magazines" }
    ];

    return HeaderMenu.create( "News", entries );
  }
}